import React from 'react';
import { Paper, BottomNavigation, BottomNavigationAction } from '@mui/material';
import { LocalBar, Home, Add, Kitchen } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material';

function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();

  const getCurrentValue = () => {
    const path = location.pathname;
    if (path === '/' || path.startsWith('/recipes')) return 0;
    if (path.startsWith('/recipe/new')) return 1;
    if (path.startsWith('/ingredients')) return 2;
    if (path.startsWith('/cocktail-menus')) return 3;
    return 0; // Default to home
  };

  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0,
        zIndex: 1000,
        borderRadius: '12px 12px 0 0',
        overflow: 'hidden',
        boxShadow: '0px -2px 10px rgba(0,0,0,0.1)',
        display: { xs: 'block', sm: 'none' },
        pb: 'env(safe-area-inset-bottom)'
      }} 
      elevation={3}
    >
      <BottomNavigation
        showLabels
        value={getCurrentValue()}
        onChange={(event, newValue) => {
          switch (newValue) {
            case 0: 
              navigate('/');
              break;
            case 1: 
              navigate('/recipe/new');
              break;
            case 2:
              navigate('/ingredients');
              break;
            case 3: 
              navigate('/cocktail-menus');
              break;
            default: 
              navigate('/');
          }
        }}
        sx={{
          height: 64,
          '& .MuiBottomNavigationAction-root': {
            minWidth: 0,
            maxWidth: 'none',
            padding: '6px 0',
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.75rem',
          },
          '& .Mui-selected': {
            color: theme.palette.primary.main,
          }
        }}
      >
        <BottomNavigationAction 
          label="Home" 
          icon={<Home sx={{ fontSize: '1.4rem' }} />} 
        />
        <BottomNavigationAction 
          label="Add Recipe" 
          icon={<Add sx={{ fontSize: '1.4rem' }} />} 
        />
        <BottomNavigationAction 
          label="Ingredients" 
          icon={<Kitchen sx={{ fontSize: '1.4rem' }} />} 
        />
        <BottomNavigationAction 
          label="My Menus" 
          icon={<LocalBar sx={{ fontSize: '1.4rem' }} />} 
        />
      </BottomNavigation>
    </Paper>
  );
}

export default BottomNav;
